"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        position: 'relative',
        backgroundColor: 'inherit'
    },
    label: {
        paddingBottom: 8,
        color: theme.grey1,
        fontSize: 16,
        fontWeight: 600,
        letterSpacing: 0,
        '[data-input-is-required="true"] > &::before': {
            content: '"* "',
            color: theme.warningRed
        }
    }
});
//# sourceMappingURL=dumblabel.style.js.map